import firebase from 'firebase/app';
import 'firebase/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyAVmZMe5VkwB_OlbV3TPX1kr0BMDrxr3-Q",
  authDomain: "spdev-f487e.firebaseapp.com",
  projectId: "spdev-f487e",
  storageBucket: "spdev-f487e.appspot.com",
  messagingSenderId: "874074027766",
  appId: "1:874074027766:web:973e45dbf5c362c9f09ed7",
  measurementId: "G-EH0WYBKZN8"
}
const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.firestore();